import { useNavigate, useParams } from 'react-router-dom';
import { useSite } from '../data/SiteContext';

export default function BlogPost() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const { posts, loading, contact } = useSite();
  const post = posts.find(p => p.slug === slug);

  if (loading) {
    return <div className="wrap" style={{ padding:'80px 0', color:'#5a726f' }}>Loading…</div>;
  }

  if (!post) {
    return (
      <div className="wrap" style={{ padding:'80px 0 96px', textAlign:'center' }}>
        <h1 className="serif" style={{ fontSize:34, marginBottom:12 }}>We couldn't find that post</h1>
        <p style={{ fontSize:16, color:'#5a726f', marginBottom:24 }}>It may have been unpublished or the link is wrong.</p>
        <span onClick={() => navigate('/blog')} className="btn btn-teal" style={{ cursor:'pointer', padding:'14px 26px' }}>← All travel guides</span>
      </div>
    );
  }

  // Authored bodies are plain text; keep paragraph breaks readable.
  const paragraphs = String(post.body || post.excerpt || '').split(/\n{2,}|\r\n\r\n/).filter(Boolean);

  return (
    <div>
      <section style={{ position:'relative', minHeight:340, display:'flex', alignItems:'flex-end', overflow:'hidden' }}>
        <div className="cover bgimg" style={{ backgroundImage:`url(${post.img})` }}></div>
        <div className="cover" style={{ background:'linear-gradient(180deg,rgba(6,40,45,0.2),rgba(6,40,45,0.82))' }}></div>
        <div style={{ position:'relative', maxWidth:900, margin:'0 auto', padding:'0 24px 40px', width:'100%', color:'#fff' }}>
          <span onClick={() => navigate('/blog')} style={{ cursor:'pointer', color:'rgba(255,255,255,0.9)', fontWeight:700, fontSize:14 }}>← All travel guides</span>
          <div style={{ fontSize:12.5, fontWeight:700, textTransform:'uppercase', letterSpacing:'.06em', marginTop:14, color:'rgba(255,255,255,0.85)' }}>
            {[post.cat, post.date, post.mins ? `${post.mins} min read` : null].filter(Boolean).join(' · ')}
          </div>
          <h1 className="serif" style={{ fontSize:'clamp(30px,4.6vw,52px)', margin:'8px 0 0', letterSpacing:'-0.5px' }}>{post.title}</h1>
        </div>
      </section>

      <div style={{ maxWidth:820, margin:'0 auto', padding:'40px 24px 72px' }}>
        {post.excerpt && (
          <p style={{ fontSize:19, lineHeight:1.7, color:'#31474a', margin:'0 0 22px' }}>{post.excerpt}</p>
        )}
        {paragraphs.map((para, i) => (
          <p key={i} style={{ fontSize:16.5, lineHeight:1.75, color:'#5a726f', margin:'0 0 18px' }}>{para}</p>
        ))}
        <a href={contact.waLink} target="_blank" rel="noreferrer" className="btn btn-teal" style={{ marginTop:12, padding:'15px 28px' }}>Ask a specialist →</a>
      </div>
    </div>
  );
}
